<template>
  <v-btn
    class="root"
    :type="type"
    :color="color"
    :flat="flat"
    :disabled="loading || disabled"
    @click="btnClick"
  >
    <span v-if="loading">
      <v-progress-circular
        indeterminate
        color="primary"
        :size="24"
      />
    </span>
    <span v-if="!loading">{{ text }}</span>
  </v-btn>
</template>

<script>
export default {
  name: 'Button',

  props: {
    text: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    flat: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    btnClick() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss" scoped>
.root {
  min-width: 100px;
  min-height: 36px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/LaddaButton.vue